export function parseFloatIntl (value) {
  if (isNaN(value)) { // likely has commas or just not a number so we need to dive deeper to fix
    // String = error
    if (typeof value === 'string' && value.match(/[^\d,.]/)) {
      return 'NaN'

      // This is formatted number in US style.  remove commans
    } else if (typeof value === 'string' && value.match(/[0-9]+,[0-9]+\.[0-9]+/)) {
      value = value.replace(',', '')

    // European style.  Change to US for easier string manipulation
    } else if (typeof value === 'string' && value.match(/[0-9]+\.[0-9]+,[0-9]+/)) {
      value = value.replace('.', '').replace(',', '.')
    } else {
      return value
    }
  }

  return value ? parseFloat(value) : ''
}

/**
 * Formats money fields to US number format.
 */
export function formatLocale (value, locale = 'en-US', sigDigits = 2) {
  value = parseFloatIntl(Number(value))

  if (value === 'NaN' || value === undefined) {
    return 'Error'
  }

  // FYI, the minimumFractionDigits and MaximumFractionDigits option, but it does not work everywhere...
  return Number(value).toLocaleString(locale, { minimumFractionDigits: sigDigits, maximumFractionDigits: sigDigits })
}

// pad 1-digit months/days
export function pad (string, pad = '0', length, justify = 'right') {
  if (typeof string !== 'string' && isNaN(string)) {
    return false
  } else if (!length) {
    return string
  } else if (string.length > length) {
    return string.substring(0, length)
  }

  // need padding
  if (justify === 'right') {
    return String(string).padStart(length, pad)
  } else {
    return String(string).padEnd(length, pad)
  }
}

// Quick way to show column numbers on the screen for easier debugging of fixed-width files
export function showColumnNumbers (length = 100, padding = 0) {
  let onesUnits = pad('', ' ', padding, 'left')
  let tensUnits = pad('', ' ', padding, 'left')
  let hundredsUnits = pad('', ' ', padding, 'left')
  for (let i = 1; i <= length; i++) {
    onesUnits += String(i).substr(-1, 1)
    tensUnits += (i % 10) ? ' ' : String(i).slice(0, -1).substr(-1, 1)
    hundredsUnits += (i % 100) ? ' ' : String(i).slice(0, -2).substr(-1, 1)
  }

  return hundredsUnits + '\r\n' + tensUnits + '\r\n' + onesUnits + '\r\n' + '\r\n'
}
